import React from 'react';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';

export interface LayoutNamePromptContentProps {
    className?: string;
    layoutName: string;
    onLayoutNameChanged: (name: string) => void;
    onEnter: () => void;
    error: string;
    isInvalid: boolean;
    title: string;
    message?: string;
    label?: string;
}

export default function LayoutNamePromptContent(
    props: LayoutNamePromptContentProps
) {
    const {
        className,
        layoutName,
        onLayoutNameChanged,
        title,
        message,
        label,
        onEnter,
        error,
        isInvalid,
    } = props;

    const cssClasses = classNames(
        'LayoutNamePromptContent',
        'modal-content',
        className
    );

    return (
        <div className={cssClasses}>
            <span className="title">{title}</span>
            {message && <div className="message">{message}</div>}
            <div className="input-with-label">
                {label && <div className="label">{label}</div>}
                {error && <div className="error">{error}</div>}
                <TextInput
                    autoFocus={true}
                    value={layoutName}
                    onChange={onLayoutNameChanged}
                    onEnter={onEnter}
                    placeholder="Enter layout name"
                    error={isInvalid}
                    maxLength={100}
                />
            </div>
        </div>
    );
}
